import React, { useMemo, useEffect, useState } from "react";

import { connect } from "react-redux";
import styled from "styled-components";
import { difference, servicePick, removeNilValues, toUTCDateTime, compareObjects, compareTwoArrays } from "utils";
import { getAccountManagersBillingList, getAccountManagersDropdownList } from "actions/account_managers";
import { getReferencesForReports } from "actions/references";
import FormHOC from "hoc/FilltersForm";
import { SCREEN_MEDIA } from "const";
import { usePrevious } from "hooks";
import DateTimeRangePicker from "components/DateRangePicker/DateTimerRangePicker";
import CheckboxBadge from "components/Form/CheckboxBadge/CheckboxBadge";
import { ButtonPrimary } from "components/base/BaseButton";
import CustomField from "components/Form/CustomField";
import Text from "components/Form/Text";
import m from "definedMessages";

import { Checkbox, CheckboxGroup, CheckPicker, DateRangePicker, Form, Input, SelectPicker } from "rsuite";

const { mx } = SCREEN_MEDIA;

const { allowedRange } = DateRangePicker;


const TrafficReportsFilters = ({
    sort,
    defaultSort,
    onApplyFilters,
    defaultFilters,
    currentFilters,
    loading,
    preFilters,
    setPreFilters,
    globalSettings = {},
    service,
    isFailedMdr,
    setSort,
    ...props
}) => {

    const isFailedMdrDefaultValues = {
        ...defaultFilters,
        operator: null,
        cntr_key_list: null,
        [servicePick(service, "supplier_key_list", "supplier_id_list")]: null,
        supplier_trunk_id_list: [],
        [servicePick(service, "sender_id", "senderid")]: null,
        mcc_mnc: null,
        sender_sde_key_list: null,
        phone_sde_key_list: null,
        reason_list: [],
        group_checkbox: [],
        only_my_account: true
    };

    const trafficMdrDefaultValues = {
        ...defaultFilters,
        ...(!service ? { operator: null, cntr_key_list: null } : {}),
        [servicePick(service, "supplier_key_list", "supplier_id_list")]: null,
        supplier_trunk_id_list: [],
        originator_key_list: null,
        account_manager_id_list: null,
        dialer_id_list: null,
        sp_key_list: null,
        [servicePick(service, "a_sde_key_list", "sender_sde_key_list")]: null,
        [servicePick(service, "b_sde_key_list", "phone_sde_key_list")]: null,
        [servicePick(service, "a_number", "senderid")]: null,
        [servicePick(service, undefined, "mcc_mnc")]: null,
        dialer_manager_id_list: null,
        group_checkbox: [],
        only_my_account: true
    };

    const [filters, setFilters] = useState(currentFilters);
    const [grouping, setGrouping] = useState(currentFilters.group_checkbox);
    const [onlyMyAccountCheck, setOnlyMyAccountCheck] = useState(true);
    const [pickedSupplier, setPickedSupplier] = useState(null);
    const [pickedSupplierTrunkList, setPickedSupplierTrunkList] = useState([]);

    const prevIsFailedMdr = usePrevious(isFailedMdr);

    const [secondUpdateFixer, setSecondUpdateFixer] = useState(null);
    const [currentFiltersComponent, setCurrentFiltersComponent] = useState(<></>);

    useEffect(() => {
        if (prevIsFailedMdr !== isFailedMdr) {
            const deafultFilterValues = isFailedMdr ? isFailedMdrDefaultValues : trafficMdrDefaultValues;
            setFilters(deafultFilterValues);

            const preDeafultFilterValues = { ...deafultFilterValues };

            if (preDeafultFilterValues.range && preDeafultFilterValues.range.length) {
                // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
                // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
                preDeafultFilterValues["start_date"] = toUTCDateTime(preDeafultFilterValues.range[0]);
                preDeafultFilterValues["end_date"] = toUTCDateTime(preDeafultFilterValues.range[1]);

                delete preDeafultFilterValues.range;
            }

            setPreFilters(removeNilValues(preDeafultFilterValues))

            setOnlyMyAccountCheck(true);

            setGrouping(deafultFilterValues?.group_checkbox);
            setSecondUpdateFixer(null);
        }
    }, [isFailedMdr]);

    // const allowedRanges = useMemo(() => {
    //     const date = new Date();
    //     const startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    //     const endDate = new Date(date.getFullYear(), date.getMonth(), 1);
    //     const intervalMonth = globalSettings.cdr_full__interval_month || 0;
    //     const dateRange = [
    //         new Date(startDate.setMonth(startDate.getMonth() - intervalMonth)),
    //         new Date(endDate.setMonth(endDate.getMonth() + 12))
    //     ];

    //     return [
    //         `${dateRange[0].getFullYear()}-${dateRange[0].getMonth() + 1}-${dateRange[0].getDate()}`,
    //         `${dateRange[1].getFullYear()}-${dateRange[1].getMonth() + 1}-${dateRange[1].getDate()}`,
    //     ];
    // }, [globalSettings]);

    const handleChange = (formValues) => {
        const filterValues = { ...formValues };
        let groupCheckboxes = filterValues.group_checkbox;
        const radioCheckboxes = ["dt_hour", "dt_day", "dt_month", "dt_year"];
        const mccMncCheckboxes = ["mcc", "mcc_mnc"];
        const changedCheckbox = difference(groupCheckboxes, grouping)[0];

        const valuesWithoutRadio1 = groupCheckboxes.filter((el) => !radioCheckboxes.includes(el));

        if (changedCheckbox && radioCheckboxes.includes(changedCheckbox)) {
            groupCheckboxes = [...valuesWithoutRadio1, changedCheckbox];
        }

        const valuesWithoutRadio2 = groupCheckboxes.filter((el) => !mccMncCheckboxes.includes(el));

        if (changedCheckbox && mccMncCheckboxes.includes(changedCheckbox)) {
            groupCheckboxes = [...valuesWithoutRadio2, changedCheckbox];
        }

        if (!service && !groupCheckboxes.includes("supplier_name")) {
            if (groupCheckboxes.includes("supplier_trunk")) {
                const index = groupCheckboxes.indexOf("supplier_trunk");
                groupCheckboxes.splice(index, 1);
            }
        }

        setGrouping(groupCheckboxes);

        const supplierIdListKey = servicePick(service, "supplier_key_list", "supplier_id_list");

        if (!service && (
            !formValues[supplierIdListKey] ||
            supplierIdListKey in formValues && supplierIdListKey in filterValues &&
            !compareTwoArrays(formValues[supplierIdListKey], filterValues[supplierIdListKey]) ||
            formValues[supplierIdListKey] && formValues[supplierIdListKey].length === 0 ||
            formValues[supplierIdListKey] && formValues[supplierIdListKey].length > 1
        )) {
            if ("supplier_trunk_id_list" in filterValues) {
                delete filterValues.supplier_trunk_id_list;
                setPickedSupplierTrunkList([]);
            }
        }

        setFilters({ ...filterValues, group_checkbox: groupCheckboxes });

        if (filterValues.range && filterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        if (
            !compareObjects(sort, defaultSort) &&
            (!!filterValues.group_checkbox?.length &&
                !filterValues.group_checkbox.includes(sort.column) ||
                !filterValues.group_checkbox?.length)
        ) {
            setSort(defaultSort);
        }

        setPreFilters(removeNilValues({ ...filterValues, group_checkbox: groupCheckboxes }));
    };

    const handleApply = () => {
        onApplyFilters(removeNilValues(preFilters));
    };

    const checkOnlyAccount = (checked) => {
        setFilters((value) => {
            return {
                ...value,
                only_my_account: checked
            };
        });
        setPreFilters((preValue) => {
            return {
                ...preValue,
                only_my_account: checked
            };
        });
        setOnlyMyAccountCheck(checked);
    };

    const checkReliability = (name, checked) => {
        setFilters((value) => ({ ...value, [name]: checked }));
        setPreFilters((value) => ({ ...value, [name]: checked }));
    };

    useEffect(() => {
        props.getReferencesForReports();
        if (service) {
            props.getAccountManagersBillingList();
        }
        props.getAccountManagersDropdownList({}, !service);
    }, [service]);

    const reasonList = props.reasonList ? props.reasonList.map((reason, idx) => { return { name: reason, key: reason } }) : [];

    const handleChangeDateTime = (value) => {
        const filter = { ...value };
        const currentDatetimeFilter = { range: [filter.range[0], filter.range[1]] };

        const filtersToUpdate = {
            ...filters,
            ...filter,
            ...currentDatetimeFilter
        };

        setFilters(filtersToUpdate);

        const filterValues = { ...filtersToUpdate };

        if (filterValues.range && filterValues.range.length) {
            // filterValues["start_date"] = toStartDayUTCTime(filterValues.range[0]);
            // filterValues["end_date"] = toEndDayUTCTime(filterValues.range[1]);
            filterValues["start_date"] = toUTCDateTime(filterValues.range[0]);
            filterValues["end_date"] = toUTCDateTime(filterValues.range[1]);

            delete filterValues.range;
        }

        setPreFilters(removeNilValues(filterValues));
    };

    const accountManagersFiltered = props.accountManagerList.filter(value => value.active || value.has_accounts);

    useEffect(() => {
        const mdrFailedFilters = <>
            {/* <CustomField
                accepter={DateRangePicker}
                cleanable={false}
                placeholder="Select Date Range"
                disabledDate={allowedRange(...allowedRanges)}
                name="range"
                width={250}
            /> */}
            <DateTimeRangePicker
                onChange={(value) => {
                    handleChangeDateTime(value);
                }}
                defaultStartDate={defaultFilters.range[0]}
                defaultEndDate={defaultFilters.range[1]}
                startDate={filters?.range[0]}
                endDate={filters?.range[1]}
                showRanges
            // input={false}
            />
            {!service ? <Text
                name="operator"
                placeholder="Operator"
                width={150}
                value={filters.operator}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                labelKey="name"
                valueKey="cntr_key"
                data={props.countryList}
                placeholder="Countries"
                name="cntr_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            /> : <></>}
            <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.supplierList}
                onChange={(supplierIdList) => {
                    if (supplierIdList && supplierIdList.length === 1) {
                        const foundSupplier = props.supplierList.find(supplier => supplier.id === supplierIdList[0]);
                        setPickedSupplier(foundSupplier || null);
                    } else {
                        setPickedSupplier(null);
                    }
                }}
                labelKey="name"
                valueKey="id"
                placeholder="Suppliers"
                name={servicePick(service, "supplier_key_list", "supplier_id_list")}
                width={200}
                menuStyle={{
                    width: 320
                }}
            />
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={pickedSupplier?.supplier_trunk_list || []}
                onChange={(supplierTrunkIdList) => {
                    setPickedSupplierTrunkList(supplierTrunkIdList);
                }}
                value={pickedSupplierTrunkList}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier trunks"
                name="supplier_trunk_id_list"
                width={200}
                searchable={false}
                disabled={!pickedSupplier}
            /> : <></>}
            <CustomField
                accepter={Input}
                width={150}
                placeholder="Sender ID"
                name={servicePick(service, "sender_id", "senderid")}
            />
            <CustomField
                accepter={Input}
                width={120}
                placeholder="MCC/MNC"
                name="mcc_mnc"
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={300}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Origins"
                name="sender_sde_key_list"
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={300}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Destinations"
                name="phone_sde_key_list"
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                width={300}
                data={reasonList}
                labelKey="name"
                valueKey="key"
                placeholder="Reason"
                name="reason_list"
                menuStyle={{
                    width: 320
                }}
            />
            {!service ?
                <Checkbox
                    name="only_my_account"
                    onChange={(value, checked) => {
                        checkOnlyAccount(checked);
                    }}
                    checked={onlyMyAccountCheck}
                    style={{ width: 240, display: "inline-block" }}
                >
                    Show only my account traffic
                </Checkbox>
                : <></>}
        </>;

        const servicePlanField = <CustomField
            accepter={CheckPicker}
            data={props.servicePlanList}
            value={filters.sp_key_list}
            labelKey="name"
            valueKey="sp_key"
            placeholder="Trunk types"
            name="sp_key_list"
            width={200}
        />;
        const trafficMdrFilters = <>
            {/* <CustomField
                accepter={DateRangePicker}
                cleanable={false}
                placeholder="Select Date Range"
                disabledDate={allowedRange(...allowedRanges)}
                name="range"
                width={250}
            /> */}
            <DateTimeRangePicker
                onChange={(value) => {
                    handleChangeDateTime(value);
                }}
                defaultStartDate={defaultFilters.range[0]}
                defaultEndDate={defaultFilters.range[1]}
                startDate={filters?.range[0]}
                endDate={filters?.range[1]}
                showRanges
            // input={false}
            />
            {!service ? <Text
                name="operator"
                placeholder="Operator"
                width={150}
                value={filters.operator}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                labelKey="name"
                valueKey="cntr_key"
                data={props.countryList}
                placeholder="Countries"
                name="cntr_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.supplierList}
                onChange={(supplierIdList) => {
                    if (supplierIdList && supplierIdList.length === 1) {
                        const foundSupplier = props.supplierList.find(supplier => supplier.id === supplierIdList[0]);
                        setPickedSupplier(foundSupplier || null);
                    } else {
                        setPickedSupplier(null);
                    }
                }}
                labelKey="name"
                valueKey="id"
                placeholder="Suppliers"
                name={servicePick(service, "supplier_key_list", "supplier_id_list")}
                width={200}
                menuStyle={{
                    width: 320
                }}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={pickedSupplier?.supplier_trunk_list || []}
                onChange={(supplierTrunkIdList) => {
                    setPickedSupplierTrunkList(supplierTrunkIdList);
                }}
                value={pickedSupplierTrunkList}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier trunks"
                name="supplier_trunk_id_list"
                width={200}
                searchable={false}
                disabled={!pickedSupplier}
            /> : <></>}
            {!service ? <CustomField
                accepter={CheckPicker}
                virtualized
                data={accountManagersFiltered}
                labelKey="name"
                valueKey="id"
                placeholder="Supplier AMs"
                name="supplier_manager_id_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            /> : <></>}
            {service ? <CustomField
                accepter={CheckPicker}
                virtualized
                labelKey="name"
                valueKey="acc_key"
                data={props.originatorList}
                placeholder="Originators"
                name="originator_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            />
                : <Text name="originator_name" placeholder="Originator" width={200} />}
            {service ? <CustomField
                accepter={CheckPicker}
                virtualized
                labelKey="ACM_NAME"
                valueKey="ACM_KEY"
                data={props.accountManagerBilList}
                placeholder="Originator AMs"
                name="originator_manager_key_list"
                width={200}
                menuStyle={{
                    width: 280
                }}
            /> : <></>}
            <CustomField
                accepter={CheckPicker}
                virtualized
                data={props.dialerList}
                value={filters.dialer_id_list}
                labelKey="name"
                valueKey="id"
                placeholder="Dialers"
                name="dialer_id_list"
                width={200}
                menuStyle={{
                    width: 320
                }}
            />
            {!service ? servicePlanField : <></>}
            {<CustomField
                accepter={CheckPicker}
                virtualized
                data={accountManagersFiltered}
                labelKey="name"
                valueKey="id"
                placeholder="Dialer AMs"
                name="dialer_manager_id_list"
                width={200}
            />}
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={200}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Origins"
                name={servicePick(service, "a_sde_key_list", "sender_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            <CustomField
                accepter={CheckPicker}
                virtualized
                width={200}
                data={props.subdestinationList}
                labelKey="name"
                valueKey="sde_key"
                placeholder="Destinations"
                name={servicePick(service, "b_sde_key_list", "phone_sde_key_list")}
                menuStyle={{
                    width: 360
                }}
            />
            {/* {!service && <br/>} */}
            {service ? <CustomField
                accepter={Input}
                width={150}
                placeholder="A-Number"
                name="a_number"
            /> : <CustomField
                accepter={Input}
                width={150}
                placeholder="Sender ID"
                name="senderid"
            />}
            {service ? servicePlanField : <></>}
            {!service ? <>
                <CustomField
                    accepter={Input}
                    width={120}
                    placeholder="MCC/MNC"
                    name="mcc_mnc"
                />
            </> : <></>}

            {!service ?
                <Checkbox
                    name="only_my_account"
                    onChange={(value, checked) => {
                        checkOnlyAccount(checked);
                    }}
                    checked={onlyMyAccountCheck}
                    style={{ width: 240, display: "inline-block" }}
                >
                    Show only my account traffic
                </Checkbox>
                : <></>}
            {!isFailedMdr && <>
                <Checkbox
                    name="show_reliable"
                    onChange={(_, checked) => checkReliability("show_reliable", checked)}
                    checked={filters.show_reliable}
                    style={{ width: 130, display: "inline-block" }}
                >
                    Show trusted
                </Checkbox>
                <Checkbox
                    name="show_not_reliable"
                    onChange={(_, checked) => checkReliability("show_not_reliable", checked)}
                    checked={filters.show_not_reliable}
                    style={{ width: 145, display: "inline-block" }}
                >
                    Show untrusted
                </Checkbox>
            </>}
        </>;

        const currentFilterComponent = isFailedMdr ? mdrFailedFilters : trafficMdrFilters;
        setCurrentFiltersComponent(currentFilterComponent);
    }, [filters, secondUpdateFixer, props.supplierList, props.dialerList, props.subdestinationList, props.originatorList, props.reasonList, isFailedMdr]);

    const mdrFailedGroups = <GroupContainer
        name="group_checkbox"
        accepter={CheckboxGroup}
        inline
        value={grouping}
    >
        <CheckboxBadge value="operator">Operator</CheckboxBadge>
        <CheckboxBadge value="country">Country</CheckboxBadge>
        <CheckboxBadge value="supplier_rate">Supplier Rate</CheckboxBadge>
        <CheckboxBadge value="supplier_name">Supplier</CheckboxBadge>
        <CheckboxBadge value="supplier_trunk" disabled={!grouping.includes("supplier_name")}>Supplier trunk</CheckboxBadge>
        <CheckboxBadge value="phone">B-Number</CheckboxBadge>
        <CheckboxBadge value="mcc_mnc">MCC/MNC</CheckboxBadge>
        <CheckboxBadge value="mcc" wrapperClassName={"mr-4"}>MCC</CheckboxBadge>
        <CheckboxBadge value="dt_hour">Hour</CheckboxBadge>
        <CheckboxBadge value="dt_day">Day</CheckboxBadge>
        <CheckboxBadge value="dt_month">Month</CheckboxBadge>
        <CheckboxBadge value="dt_year">Year</CheckboxBadge>

        <br />
        <CheckboxBadge value="sender_wz_name">Zone (origin)</CheckboxBadge>
        <CheckboxBadge value="phone_wz_name">Zone (dest)</CheckboxBadge>
        <CheckboxBadge value="sender_de_name">Dest (origin)</CheckboxBadge>
        <CheckboxBadge value="phone_de_name">Dest (dest)</CheckboxBadge>
        <CheckboxBadge value="sender_sde_name">Subdest (origin)</CheckboxBadge>
        <CheckboxBadge value="phone_sde_name">Subdest (dest)</CheckboxBadge>
        <CheckboxBadge value="senderid">Sender ID</CheckboxBadge>
        <CheckboxBadge value="reason">Reason</CheckboxBadge>
    </GroupContainer>;

    const trafficMdrGroups = service ? <GroupContainer
        name="group_checkbox"
        accepter={CheckboxGroup}
        inline
        value={grouping}
    >
        <CheckboxBadge value="a_number">A-Number</CheckboxBadge>
        <CheckboxBadge value="b_number">B-Number</CheckboxBadge>
        <CheckboxBadge value="range_name">Range</CheckboxBadge>
        <CheckboxBadge value="originator_name">Originator</CheckboxBadge>
        <CheckboxBadge value="originator_manager_name">Originator AM</CheckboxBadge>
        <CheckboxBadge value="originator_rate">Originator rate</CheckboxBadge>
        <CheckboxBadge value="dialer_name">Dialer</CheckboxBadge>
        <CheckboxBadge value="dialer_nickname">Dialer Nickname</CheckboxBadge>
        <CheckboxBadge value="dialer_manager_name">Dialer AM</CheckboxBadge>
        <CheckboxBadge value="service_plan_name">Trunks</CheckboxBadge>
        <CheckboxBadge value="dialer_rate">Dialer rate</CheckboxBadge>
        <CheckboxBadge value="dt_hour">Hour</CheckboxBadge>
        <CheckboxBadge value="dt_day">Day</CheckboxBadge>
        <CheckboxBadge value="dt_month">Month</CheckboxBadge>
        <CheckboxBadge value="dt_year">Year</CheckboxBadge>
        <br />
        <CheckboxBadge value="dialer_is_reliable">Trusted</CheckboxBadge>
        <CheckboxBadge value="a_wz_name">Zone (origin)</CheckboxBadge>
        <CheckboxBadge value="b_wz_name">Zone (dest)</CheckboxBadge>
        <CheckboxBadge value="a_de_name">Dest (origin)</CheckboxBadge>
        <CheckboxBadge value="b_de_name">Dest (dest)</CheckboxBadge>
        <CheckboxBadge value="a_sde_name">Subdest (origin)</CheckboxBadge>
        <CheckboxBadge value="b_sde_name">Subdest (dest)</CheckboxBadge>
        <CheckboxBadge value="margin" >Margin</CheckboxBadge>
    </GroupContainer>
        : <GroupContainer
            name="group_checkbox"
            accepter={CheckboxGroup}
            inline
            value={grouping}
        >
            <CheckboxBadge value="range_name">Range</CheckboxBadge>
            <CheckboxBadge value="originator_name">Originator</CheckboxBadge>
            <CheckboxBadge value="operator">Operator</CheckboxBadge>
            <CheckboxBadge value="country">Country</CheckboxBadge>
            <CheckboxBadge value="supplier_rate">Supplier Rate</CheckboxBadge>
            <CheckboxBadge value="supplier_name">Supplier</CheckboxBadge>
            <CheckboxBadge value="supplier_trunk" disabled={!grouping.includes("supplier_name")}>Supplier trunk</CheckboxBadge>
            <CheckboxBadge value="supplier_manager">Supplier AM</CheckboxBadge>
            <CheckboxBadge value="dialer_rate">Dialer Rate</CheckboxBadge>
            <CheckboxBadge value="dialer_name">Dialer</CheckboxBadge>
            <CheckboxBadge value="dialer_nickname">Dialer Nickname</CheckboxBadge>
            <CheckboxBadge value="service_plan_name">Trunk</CheckboxBadge>
            <CheckboxBadge value="dialer_manager">Dialer AM</CheckboxBadge>
            <CheckboxBadge value="phone">B-Number</CheckboxBadge>
            <CheckboxBadge value="mcc_mnc">MCC/MNC</CheckboxBadge>
            <CheckboxBadge value="mcc">MCC</CheckboxBadge>
            <br />
            <CheckboxBadge value="dt_hour">Hour</CheckboxBadge>
            <CheckboxBadge value="dt_day">Day</CheckboxBadge>
            <CheckboxBadge value="dt_month">Month</CheckboxBadge>
            <CheckboxBadge value="dt_year" wrapperClassName={"mr-5"}>Year</CheckboxBadge>

            <CheckboxBadge value="dialer_is_reliable">Trusted</CheckboxBadge>
            <CheckboxBadge value="delivery_status">Delivery Status</CheckboxBadge>
            <CheckboxBadge value="sender_wz_name">Zone (origin)</CheckboxBadge>
            <CheckboxBadge value="phone_wz_name">Zone (dest)</CheckboxBadge>
            <CheckboxBadge value="sender_de_name">Dest (origin)</CheckboxBadge>
            <CheckboxBadge value="phone_de_name">Dest (dest)</CheckboxBadge>
            <CheckboxBadge value="sender_sde_name">Subdest (origin)</CheckboxBadge>
            <CheckboxBadge value="phone_sde_name">Subdest (dest)</CheckboxBadge>
            <CheckboxBadge value="senderid">Sender ID</CheckboxBadge>
            <CheckboxBadge value="reason">Reason</CheckboxBadge>
        </GroupContainer>;

    const currentGroups = isFailedMdr ? mdrFailedGroups : trafficMdrGroups;

    return (
        <>
            <Form
                layout="inline"
                onChange={handleChange}
                formDefaultValue={defaultFilters}
                formValue={filters}
            >
                <Form.ControlLabel className={"d-block mb-2"}>Filters</Form.ControlLabel>
                {currentFiltersComponent}
                <br />
                <Form.Group>
                    <Form.ControlLabel className={"d-block"}>Group by</Form.ControlLabel>
                    {currentGroups}
                </Form.Group>
                <FormGroupRight>
                    <ButtonPrimary
                        style={{
                            padding: "8px 34px",
                            marginLeft: 12
                        }}
                        onClick={handleApply}
                        disabled={loading}
                    >
                        Apply filters
                    </ButtonPrimary>
                </FormGroupRight>
            </Form>
        </>
    );
};

const mapStateToProps = ({ references, traffic_reports, account_managers, auth }) => ({
    service: auth.service,
    loading: traffic_reports.loading,
    originatorList: references.client_list,
    reasonList: references["sms.reason_list"],
    dialerList: auth.service ? references.dialer_list : references["sms.dialer_list"],
    supplierList: auth.service ? references.supplier_list : references["sms.supplier_list"],
    servicePlanList: references.service_plan_list,
    countryList: references.country_list,
    accountManagerBilList: account_managers.billingList,
    accountManagerList: account_managers.dropdown_list,
    subdestinationList: references.subdestination_list,
});

const mapDispatchToProps = {
    getReferencesForReports,
    getAccountManagersBillingList,
    getAccountManagersDropdownList
};

export default connect(mapStateToProps, mapDispatchToProps)(FormHOC(TrafficReportsFilters));

const FormGroupRight = styled(Form.Group)`
    && {
        float: right;
        position: relative;
        height: 120px;
        margin-right: 0;
    }

    && button {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 160px;
    }

    @media (max-width: ${mx.min}px) {
        && {
            height: fit-content;
        }

        && button {
            position: relative;
        }
    }
`;
const GroupContainer = styled(Form.Group)`
    && {
        display: flex;
        flex-wrap: wrap;
        max-width: 100%;
        margin-bottom: 0px;
        padding-left: 10px;
        row-gap: 4px;
    }
`;
